import React, { Component } from "react";

// Components
import SaveBtn from "../../utils/edit-item/SaveBtn";
import DeleteBtn from "../../utils/edit-item/DeleteBtn";

// Utils
import { handleKeyPress } from "../../../utils/forms/inputHandling";

// CSS
import "../../../css/forms/edit-item.css";

class TrainingVideoSurveyItemAdmin extends Component {
	render() {
		const { item, updateLoading } = this.props;

		return (
			<div
				className={
					"edit-item edit-item--rows" + (item.successfull ? ` successful-row` : ``)
				}
			>
				<div className="item-row">
					<input
						type="text"
						id="vimeoID"
						placeholder="Enter video ID"
						maxLength="255"
						disabled={updateLoading}
						value={item.vimeoID}
						onKeyPress={e => handleKeyPress(e, this.props.handleSubmit)}
						onChange={this.props.handleInputChange}
					/>
					<div className="btn-wrap">
						<SaveBtn
							shown={!!item.titleChanged}
							loading={!!item.saving}
							disabled={!!item.saving}
							onClick={this.props.handleSubmit}
						/>
						<DeleteBtn
							loading={!!item.saving}
							disabled={!!item.saving}
							onClick={this.props.deleteItem}
						/>
					</div>
				</div>
				<div className="item-row">
					<input
						type="url"
						id="survey_url"
						placeholder="Enter survey url"
						maxLength="255"
						disabled={updateLoading}
						value={item.survey_url}
						onKeyPress={e => handleKeyPress(e, this.props.handleSubmit)}
						onChange={this.props.handleInputChange}
					/>
				</div>
			</div>
		);
	}
}

export default TrainingVideoSurveyItemAdmin;



// WEBPACK FOOTER //
// ./src/components/admin/training-video-surveys/TrainingVideoSurveyItemAdmin.js